import type { Partner } from "./partner"
import type { Provider } from "./provider"
import type { Transport } from "./transport"

export interface Invoice {
    id: string
    number: string
    partner_id: string
    partner?: Partner
    subscriptions: InvoiceSubscription[]
    unit_price: number
    total: number
    settled_at?: string
    voided_at?: string
    created_at: string
    updated_at: string
}

export enum InvoiceStatus {
    open = 'open',
    settled = 'settled',
    voided = 'voided',
}

export interface InvoiceSubscription {
    subscription_id?: string
    subscription_created_date?: string
    subscription_expiry_date?: string
    subscription_unit_price?: number
    subscription_validity_days?: string
    subscription_validity_months?: string
    customer_name?: string
}

export interface ProviderInvoice {
    id: string
    number: number
    provider_id: string
    provider?: Provider
    commission_percentage: number
    transports?: Transport[]
    total?: number
    settled_at?: string
    voided_at?: string
    created_at: string
    updated_at: string
}
